module.exports = __webpack_public_path__ + "img/11.28a1c33e.png";